import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { ChartBarIcon } from '@moia-dev/pace-icons'
import { VehicleMonitoringAreaRoutes } from './VehicleMonitoringAreaRoutes'

export const VehicleMonitoringAreaNavigationIcon = ChartBarIcon

export const VehicleMonitoringAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={VehicleMonitoringAreaRoutes.route}
      Icon={ChartBarIcon}
    />
  )
}
